import React, {Component} from "react"
import PropTypes from "prop-types"

import FormattedMessage from "@irati/utils/lang"
import History from "@irati/utils/history"
import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import adminTracking from "@irati-tracking/admin/admin"

import {VIEW_PEOPLE, VIEW_TEAM} from "../../../../routes/routeConfig"

interface Props {
  uuid: string
  teamName: string
  isRegion: boolean
  source: string
}

class EditTeamButton extends Component<Props> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  handleEditTeamClick = () => {
    const {uuid, teamName, isRegion} = this.props
    adminTracking.reporting({
      source: this.props.source,
      type: "overall_teamAnalysis",
      action: "viewTeam"
    })

    if (isRegion) {
      History.push(
        {
          pathname: VIEW_PEOPLE,
          state: {businessUnitId: uuid}
        },
        this.context
      )
    } else {
      History.push(
        {
          pathname: VIEW_TEAM,
          state: {teamName}
        },
        this.context
      )
    }
  }

  render() {
    const buttonText = this.props.isRegion
      ? "admin.components.teamEngagement.teamBreakdown.regionsButton"
      : "admin.components.teamEngagement.teamBreakdown.button"

    return (
      <Button id={buttonText} small onClick={this.handleEditTeamClick}>
        <FormattedMessage id={buttonText} />
        <Icon icon={IconTypes.arrowRight} marginLeft={1} />
      </Button>
    )
  }
}

export default EditTeamButton
